import React from "react";
import Cartcomponents from "../components/Cart/Cartcomponents";

function Cart() {
    
    
  return (
    <>
      <Cartcomponents />
    </>
  );
}

export default Cart;
